import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SharedModule } from '../../shared.module';

@Component({
  selector: 'app-switch-button',
  standalone: true,
  imports: [SharedModule],
  templateUrl: './switch-button.component.html',
  styleUrl: './switch-button.component.scss',
})
export class SwitchButtonComponent {
  @Input() checked: boolean = false;
  @Input() label: string = '';
  @Input() isDisabled: boolean = false;
  @Output() onClick: EventEmitter<any> = new EventEmitter();

  handleClick() {
    this.onClick.emit();
  }
}
